module.exports = __webpack_public_path__ + "img/part4-rIcon3-3.03be7651.png";